import { Controller } from "react-hook-form";
import { FBasicPropos } from "../../../interfaces/User.interface";
import { InputAdornment, TextField } from "@mui/material";

export const FNumberField: React.FC<FBasicPropos> = ({
    field,
    control,
    errors,
    props, 
    errorMessage
}) => {
    const { name, editable, icon, inputProps } = field;
    const isDisabled = editable === false || field.props?.disabled;
    if (!errorMessage) errorMessage = errors[name]?.message as string;



    return (
        <Controller
            name={name}
            control={control}
            // defaultValue={preFilled ? preFilled : (defaultValue ? defaultValue : undefined)}
            render={({ field: controllerField }) => {
                const handleNumberChange = (event: React.ChangeEvent<HTMLInputElement>) => {
                    const value = event.target.value.replace(/[^0-9]/g, '');
                    controllerField.onChange(value);
                };
                if (icon) {
                    return (
                        <TextField
                            {...controllerField}
                            value={controllerField.value || ''}
                            type="text"
                            label={field.question}
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            error={!!errors[name] || !!errorMessage}
                            helperText={errorMessage}
                            disabled={editable === false || props?.disabled}
                            placeholder={field.question}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        {icon}
                                    </InputAdornment>
                                ),
                                ...inputProps,
                            }}
                            onChange={handleNumberChange}
                            {...props}
                            // required={field.required}
                        />
                    );
                } else {
                    return (
                        <TextField
                            {...controllerField}
                            value={controllerField.value || ''}
                            type="text"
                            label={field.question}
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            error={!!errors[name] || !!errorMessage}
                            helperText={errorMessage}
                            disabled={editable === false || props?.disabled}
                            inputProps={{ ...inputProps,readOnly: isDisabled, style: isDisabled ? { color: '#999' } : {}}}
                            onChange={handleNumberChange}
                            {...props}
                            // required={field.required}
                        />
                    );
                }
            }}
        />
    );
};
